import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { BaseTableService } from '../base-tables/base-table.service';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICall } from './call';
import { ICallTopic } from './call-topic';
import { IFollowup } from './followup';
import { IInquiry } from './inquiry';
import { InquiryService } from './inquiry.service';
import { ITopic } from '../base-tables/topic';
import { IContactType } from '../base-tables/contact-type';
import { ISearchResult } from './search-result';
import { ISearchRequest } from './search-request';
import { CALL_TRACKER } from '@shared/utils/app-static-data';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { combineLatest } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.component.html',
  styleUrls: ['./inquiry.component.scss']
})

export class InquiryComponent implements OnInit, AfterViewInit {
  @ViewChild('TablePaginator')
  set searchPaginator(paginator: MatPaginator) {
    this.paginator = paginator;
    this.attachTableControls();
  }

  @ViewChild('TableSort')
  set searchSort(sort: MatSort) {
    this.sort = sort;
    this.attachTableControls();
  }

  @ViewChild('inquiryShell') inquiryShell: ElementRef<HTMLDivElement>;
  public uiData = CALL_TRACKER;
  public pageSize: number = 50;  
  public dataSource: MatTableDataSource<any>;  
  public isMobile: boolean = false;  
  public possibleMatches: boolean = false;
  public tableDisplayData = {
    columns: ['firstName','lastName','programId','topics','date','employeeId','contactTypeId','countyId','actions'],
    display: [
      {columnName: 'firstName', displayName: 'First Name', type: 'string', size: '13'},
      {columnName: 'lastName', displayName: 'Last Name', type: 'string', size: '13'},
      {columnName: 'programId', displayName: 'Program', type: 'lookup', size: '10'},
      {columnName: 'topics', displayName: 'Topics', type: 'topics', size: '15'},
      {columnName: 'date', displayName: 'Date', type: 'date', size: '10'},
      {columnName: 'employeeId', displayName: 'Employee', type: 'lookup', size: '12'},
      {columnName: 'contactTypeId', displayName: 'Contact Type', type: 'lookup', size: '10'},
      {columnName: 'countyId', displayName: 'County', type: 'lookup', size: '10'}
    ]
  };

  @ViewChild('search', ({ static: true }) as any) private search;
  @ViewChild('alert', ({ static: true }) as any) private alert;
  Math: Math = Math;  
  inquiry: IInquiry;
  call: ICall;
  currentTopic: ICallTopic = {
    callId: 0,
    callTopicId: 0,
    topic1Id: 0,
    topic2Id: 0,
    topic3Id: 0
  };
  callTopics: ICallTopic[] = [];
  followups: IFollowup[] = [];
  primaryTopics: ITopic[];
  inquirySecondaryTopics: ITopic[] = [];
  inquiryTertiaryTopics: ITopic[] = [];
  primaryContacts: IContactType[] = [];
  secondaryContacts: IContactType[] = [];
  searchSecondaryTopics: ITopic[] = [];
  searchTertiaryTopics: ITopic[] = [];
  searchResults: ISearchResult[] = [];
  possibleMatchResults: ISearchResult[] = [];
  displayedResults: ISearchResult[] = [];
  paginator: MatPaginator;
  sort: MatSort;
  filteredUsers: any[] = [];
  selectedEmployee: any = null;
  date: Date = new Date();
  currentDateString: string = new Date(this.date.getTime() - (this.date.getTimezoneOffset() * 60000)).toISOString().substring(0, 16);
  csvFileName: string = "SearchResults.csv";
  modalText: string = '';
  minutesInAnHour: number = 60;
  isSearch: boolean = true;
  isInquiry: boolean = false;
  showSearch: boolean = false;
  searchViewMode: 'search' | 'possibleMatches' = 'search';
  shellHeight: number = null;
  page: number = 1;  
  programId: number = this.baseService?.programs?.find(program => program.shortDescription == 'EPH')?.programId;  
  actionId: number = this.baseService?.actions?.find(action => action.shortDescription == 'Provided Information')?.actionId;
  callTopicsValid: boolean = true;
  callForm = new FormGroup({
    callId: new FormControl(0),
    contactDate: new FormControl(this.currentDateString, [Validators.required]),
    contactTime: new FormControl(''),
    employeeId: new FormControl(this.baseService.user.userId),
    confidential: new FormControl(false),
    programId: new FormControl(this.programId),
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    stateId: new FormControl('OR'),
    countyId: new FormControl(0),
    zipCode: new FormControl(''),
    country: new FormControl(''),
    contactTypeId1: new FormControl(1),
    contactTypeId2: new FormControl(0),
    organization: new FormControl(''),
    siteTypeId: new FormControl(1),
    contactMethodId: new FormControl(1),
    phone1: new FormControl(''),
    phone2: new FormControl(''),
    emailAddress: new FormControl(''),
    statusId: new FormControl(1),
    actionId: new FormControl(this.actionId),
    referredById: new FormControl(1),
    referredToId: new FormControl(1),
    timeSpent: new FormControl(0),
    notes: new FormControl(''),
    timeSpentGroup: new FormGroup({
      hours: new FormControl(0),
      minutes: new FormControl(0),
    }, {validators: this.validateInquiryTimeSpent()}),
    topicForm: new FormGroup({
      topic1Id: new FormControl(0),
      topic2Id: new FormControl(0),
      topic3Id: new FormControl(0)
    })
  });
  followupForm = new FormGroup({
    followupId: new FormControl(0),
    callId: new FormControl(0),
    followupDate: new FormControl('', [Validators.required]),
    followupTime: new FormControl(''),
    employeeId: new FormControl(this.baseService.user.userId),
    actionId: new FormControl(this.actionId),
    timeSpent: new FormControl(0),
    notes: new FormControl(''),
    timeSpentGroup: new FormGroup({
      hours: new FormControl(0),
      minutes: new FormControl(0),
    }, { validators: this.validateInquiryTimeSpent() }),
  });
  searchForm = new FormGroup({
    programId: new FormControl(0),
    employeeId: new FormControl(''),
    contactTypeId: new FormControl(0),
    countyId: new FormControl(0),
    fromDate: new FormControl(null),
    toDate: new FormControl(null),
    topicId: new FormControl(0),
    secondTopicId: new FormControl(0),
    tertiaryTopicId: new FormControl(0),
    statusId: new FormControl(0)
  });

  constructor( private inquiryService: InquiryService,
               public toastr: ToastrService,
               private readonly breakpointObserver: BreakpointObserver,
               public baseService: BaseTableService,
               public modalService: NgbModal,
               private cdr: ChangeDetectorRef ){
                    this.breakpointObserver.observe([
                      Breakpoints.Handset,
                      Breakpoints.Tablet,
                      Breakpoints.Small,
                    ]).subscribe(result => {
                      this.isMobile = result.matches;
                    });
               }

  ngOnInit(): void {
    const checkLookupsLoaded = setInterval(() => {
      if(this.baseService.lookupsLoaded) {
        this.primaryTopics = this.baseService?.topics?.filter(topic => topic.topicId == topic.parentId);
        this.primaryContacts = this.baseService?.contactTypes?.filter(type => type.contactTypeId == type.parentId);
        this.filteredUsers = this.baseService.users.slice();
        clearInterval(checkLookupsLoaded);
      }
    }, 100);

    this.setupCallFormDebounce();
  }

  ngAfterViewInit(): void {
    window.requestAnimationFrame(() => {
      this.updateShellHeight();
      this.cdr.detectChanges();
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateShellHeight();
  }

  private updateShellHeight(): void {
    if (!this.inquiryShell?.nativeElement) {
      return;
    }

    const shellTop = this.inquiryShell.nativeElement.getBoundingClientRect().top;
    const footerHeight = document.querySelector('app-footer')?.getBoundingClientRect().height ?? 0;
    const viewportPadding = 16;

    this.shellHeight = Math.max(window.innerHeight - shellTop - footerHeight - viewportPadding, 480);
  }

  setupCallFormDebounce(){
    combineLatest([
      this.callForm.get('firstName')!.valueChanges,
      this.callForm.get('lastName')!.valueChanges
    ]).pipe(
      debounceTime(300),
      filter(([first, last]) => !!first && !!last && first.length > 0 && last.length > 0)
    ).subscribe(([first, last]) => {
      this.onNameFieldsChanged(first, last);
    });
    this.possibleMatches = false;
  }

  onNameFieldsChanged(first: string, last: string) {    
    this.inquiryService.getMatches(first, last).subscribe(result=>{
      this.possibleMatchResults = result;
      this.possibleMatches = result.length > 0;

      if (this.showSearch && this.searchViewMode === 'possibleMatches') {
        this.setDisplayedResults(this.possibleMatchResults);
      }
    },error=>{console.log('error', error)},);
  }

  resetFilters(): void {
    this.searchForm.reset({
      programId: 0,
      employeeId: '',
      contactTypeId: 0,
      countyId: 0,
      fromDate: null,
      toDate: null,
      topicId: 0,
      secondTopicId: 0,
      tertiaryTopicId: 0,
      statusId: 0
    });
    this.selectedEmployee = null;
    this.filteredUsers = this.baseService.users.slice();
    this.searchSecondaryTopics = [];
    this.searchTertiaryTopics = [];
    this.searchViewMode = 'search';
    this.setDisplayedResults(this.searchResults);
  }

  filterEmployees(searchText: string = ''): void {
    const search = searchText?.toLowerCase() || '';
    if (!search || search.length < 2) {
      this.filteredUsers = this.baseService.users.slice();
    } else {
      this.filteredUsers = this.baseService.users.filter(user =>
        (user.firstName + ' ' + user.lastName).toLowerCase().includes(search) ||
        (user.lastName + ', ' + user.firstName).toLowerCase().includes(search)
      );
    }
  }

  displayEmployee = (user: any): string => {
    return user ? `${user.lastName}, ${user.firstName}` : '';
  }

  onEmployeeSelected(event: any): void {
    if (event.option.value) {
      this.searchForm.patchValue({ employeeId: event.option.value.userId });
    }
  }

  getTableDisplayLookup(id: string, type: string): string{
    var returnValue = '';

    switch(type) {
      case 'programId':
        returnValue = this.baseService.programLookup[id];
        break;
      case 'contactTypeId':
        returnValue = this.baseService.contactTypeLookup[id];
        break;
      case 'countyId':
        returnValue = this.baseService.countyLookup[id];
        break;
      case 'employeeId':
        returnValue = this.baseService.userLookup[id];
        break;
      case 'topic':
        returnValue = this.baseService.topicLookup[id];
        break;
    }

    return returnValue;
  }

  getTopicDisplay(topics: any[]): string{
    var returnValue = '';
    for (let topic of topics) {
      if (returnValue.length > 0) {
        returnValue += ', ';
      }
      returnValue += this.baseService.topicLookup[topic.topic1Id];
      if (topic.topic2Id > 0) {
        returnValue += ' > ' + this.baseService.topicLookup[topic.topic2Id];
      }
      if (topic.topic3Id > 0) {
        returnValue += ' > ' + this.baseService.topicLookup[topic.topic3Id];
      }
    }
    return returnValue;
  }

  validateInquiryTimeSpent(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const hours = control.value.hours;
      const minutes = control.value.minutes;
      return (hours > 0 || minutes > 0) ? null : { isZero: true };
    };
  }

  addTopic() {
    let callTopic: ICallTopic = {
      callId: this.callForm.value.callId,
      callTopicId: 0,
      topic1Id: this.currentTopic.topic1Id,
      topic2Id: this.currentTopic.topic2Id,
      topic3Id: this.currentTopic.topic3Id
    }
    this.callTopics.push(callTopic);
    this.callTopicsValid = true;
    this.callForm.get('topicForm.topic1Id').patchValue(0);
    this.callForm.get('topicForm.topic2Id').patchValue(0);
    this.callForm.get('topicForm.topic3Id').patchValue(0);
    this.currentTopic.topic1Id = 0;
    this.currentTopic.topic2Id = 0;
    this.currentTopic.topic3Id = 0;
    this.inquirySecondaryTopics = [];
    this.inquiryTertiaryTopics = [];
  }

  updateSecondaryTopics(topicId: string, isSearch: boolean) {
    const currentTopicId = Number(topicId);
    const matchingTopics = this.baseService.topics.filter(topic => topic.parentId === currentTopicId && topic.parentId !== topic.topicId);

    if (isSearch) {
      this.searchSecondaryTopics = matchingTopics;
      this.searchTertiaryTopics = [];
      this.searchForm.get('secondTopicId').patchValue(0);
      this.searchForm.get('tertiaryTopicId').patchValue(0);
      return;
    }

    this.currentTopic.topic1Id = currentTopicId;
    this.inquirySecondaryTopics = matchingTopics;
    this.inquiryTertiaryTopics = [];
    this.callForm.get('topicForm.topic2Id').patchValue(0);
    this.callForm.get('topicForm.topic3Id').patchValue(0);
    if (this.inquirySecondaryTopics.length == 0) {
      this.addTopic();
    }
  }

  updateTertiaryTopics(secondaryId: string, isSearch: boolean) {
    const currentSecondaryId = Number(secondaryId);
    const matchingTopics = this.baseService.topics.filter(topic => topic.parentId === currentSecondaryId && topic.parentId !== topic.topicId);

    if (isSearch) {
      this.searchTertiaryTopics = matchingTopics;
      this.searchForm.get('tertiaryTopicId').patchValue(0);
      return;
    }

    this.currentTopic.topic2Id = currentSecondaryId;
    this.inquiryTertiaryTopics = matchingTopics;
    this.callForm.get('topicForm.topic3Id').patchValue(0);
    if (this.inquiryTertiaryTopics.length == 0) {
      this.addTopic();
    }
  }

  setTertiaryTopic(tertiaryId: string) {
    this.currentTopic.topic3Id = Number(tertiaryId);
    this.addTopic();
  }

  deleteCallTopic(callTopic: ICallTopic) { 
    this.callTopics = this.callTopics.filter(topic => topic !== callTopic);
    this.callTopicsValid = this.callTopics.length > 0;
  }

  updateSecondaryContacts(contactId: string) {
    this.secondaryContacts = [];
    this.callForm.get('contactTypeId2').patchValue(0);
    this.secondaryContacts = this.baseService.contactTypes.filter(contact => contact.parentId === Number(contactId) && contact.parentId !== contact.contactTypeId);
  }

  formControlValid(control: AbstractControl): boolean {
    return !(control.invalid && (control.touched || control.dirty));
  }

  newInquiry() {
    this.updateDate()
    this.callForm.reset({
      callId: 0,
      contactDate: this.currentDateString,
      contactTime: '',
      employeeId: this.baseService.user.userId,
      confidential: false,
      programId: this.programId,
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      stateId: 'OR',
      countyId: 0,
      zipCode: '',
      country: '',
      contactTypeId1: 1,
      contactTypeId2: 0,
      organization: '',
      siteTypeId: 1,
      contactMethodId: 1,
      phone1: '',
      phone2: '',
      emailAddress: '',
      statusId: 1,
      actionId: this.actionId,
      referredById: 1,
      referredToId: 1,
      timeSpent: 0,
      notes: '',
    }, { emitEvent: true });
    this.callForm.get('timeSpentGroup.hours').patchValue(0);
    this.callForm.get('timeSpentGroup.minutes').patchValue(0);
    this.callForm.get('topicForm.topic1Id').patchValue(0);
    this.callForm.get('topicForm.topic2Id').patchValue(0);
    this.callForm.get('topicForm.topic3Id').patchValue(0);
    this.callTopics = [];
    this.inquirySecondaryTopics = [];
    this.inquiryTertiaryTopics = [];
    this.callTopicsValid = true;
    this.showSearch = false;
    this.setupCallFormDebounce();    
  }

  editInquiry(callId: number) {
    this.inquiryService.getInquiry(callId).subscribe(
      response => this.inquiry = response,
      error => console.log('error', error),
      () => this.refreshInquiry(this.inquiry)
    );
    this.inquiryService.getFollowups(callId).subscribe(
      response => this.followups = response,
      error => console.log('error', error),
      () => this.closePopup()
    );
  }

  submitInquiry() {
    if (this.callForm.valid && this.callTopics.length > 0) {      
      let callForm = this.callForm.value;
      let inquiry: IInquiry = {
        call: {
          callId: callForm.callId,
          contactDate: callForm.contactDate,
          contactTime: null,
          employeeId: callForm.employeeId,
          confidential: callForm.confidential,
          programId: Number(callForm.programId),
          firstName: callForm.firstName,
          lastName: callForm.lastName,
          address1: callForm.address1,
          address2: callForm.address2,
          city: callForm.city,
          stateId: callForm.stateId,
          countyId: Number(callForm.countyId),
          zipCode: callForm.zipCode,
          country: callForm.country,
          contactTypeId1: Number(callForm.contactTypeId1),
          contactTypeId2: Number(callForm.contactTypeId2),
          organization: callForm.organization,
          siteTypeId: Number(callForm.siteTypeId),
          contactMethodId: Number(callForm.contactMethodId),
          phone1: callForm.phone1,
          phone2: callForm.phone2,
          emailAddress: callForm.emailAddress,
          statusId: Number(callForm.statusId),
          actionId: Number(callForm.actionId),
          referredById: Number(callForm.referredById),
          referredToId: Number(callForm.referredToId),
          timeSpent: (callForm.timeSpentGroup.hours * this.minutesInAnHour) + callForm.timeSpentGroup.minutes,
          notes: callForm.notes,
        },
        topics: this.callTopics
      }

      this.inquiryService.saveInquiry(inquiry).subscribe(
        response => {
          inquiry = response
          this.toastr.success('Inquiry saved successfully.');
        },
        error => console.log(error),
        () => {
          this.modalText = 'Inquiry Saved';
          this.openVerticallyCentered(this.alert, 'sm');
          this.refreshInquiry(inquiry);
          setTimeout(() => this.closePopup(), 750)
        }
      )
    }
    else {      
      this.callTopicsValid = this.callTopics.length > 0;
      this.callForm.markAllAsTouched();
      this.callForm.get('timeSpentGroup.hours').markAllAsTouched();
      this.callForm.get('timeSpentGroup.minutes').markAllAsTouched();
      this.toastr.error('Error saving inquiry: ' + (this.callTopicsValid ? '' : 'A Topic is Required. ') + (!this.formControlValid(this.callForm.get('timeSpentGroup')) ? 'Time Spent is Required.' : ''));
    }
  }

  refreshInquiry(inquiry: IInquiry) {
    let call: ICall = inquiry.call;
    this.callTopics = inquiry.topics;
    this.callForm.reset({
      callId: call.callId,
      contactDate: call.contactDate,
      contactTime: null,
      employeeId: call.employeeId,
      confidential: call.confidential,
      programId: call.programId,
      firstName: call.firstName,
      lastName: call.lastName,
      address1: call.address1,
      address2: call.address2,
      city: call.city,
      stateId: call.stateId,
      countyId: call.countyId,
      zipCode: call.zipCode,
      country: call.country,
      contactTypeId1: call.contactTypeId1,
      contactTypeId2: call.contactTypeId2,
      organization: call.organization,
      siteTypeId: call.siteTypeId,
      contactMethodId: call.contactMethodId,
      phone1: call.phone1,
      phone2: call.phone2,
      emailAddress: call.emailAddress,
      statusId: call.statusId,
      actionId: call.actionId,
      referredById: call.referredById,
      referredToId: call.referredToId,
      timeSpent: call.timeSpent,
      notes: call.notes,
    });
    this.updateDate();
    this.followupForm.patchValue({
      followupDate: this.currentDateString
    });
    this.callForm.get('timeSpentGroup.hours').patchValue(Math.floor(call.timeSpent / this.minutesInAnHour));
    this.callForm.get('timeSpentGroup.minutes').patchValue(call.timeSpent % this.minutesInAnHour);
    this.callForm.get('topicForm.topic1Id').patchValue(0);
    this.callForm.get('topicForm.topic2Id').patchValue(0);
    this.callForm.get('topicForm.topic3Id').patchValue(0);
    this.inquirySecondaryTopics = [];
    this.inquiryTertiaryTopics = [];
    this.callTopicsValid = true;    
    this.setupCallFormDebounce();
  }

  editFollowup(followupEdit: IFollowup) {
    this.followups = this.followups.filter(followup => followup !== followupEdit);
    this.followupForm.reset({
      followupId: followupEdit.followupId,
      callId: this.callForm.value.callId,
      followupDate: followupEdit.followupDate,
      followupTime: null,
      employeeId: this.baseService.user.userId,
      actionId: Number(followupEdit.actionId),
      timeSpent: followupEdit.timeSpent,
      notes: followupEdit.notes,
    }, { emitEvent: true })
    this.followupForm.get('timeSpentGroup.hours').patchValue(Math.floor(followupEdit.timeSpent / this.minutesInAnHour));
    this.followupForm.get('timeSpentGroup.minutes').patchValue(followupEdit.timeSpent % this.minutesInAnHour);
  }

  submitFollowup() {
    if (this.followupForm.valid) {
      let formFollowup = this.followupForm.value;
      let followup: IFollowup = {
        actionId: Number(formFollowup.actionId),
        callId: this.callForm.value.callId,
        employeeId: formFollowup.employeeId,
        followupDate: formFollowup.followupDate,
        followupId: formFollowup.followupId,
        followupTime: null,
        notes: formFollowup.notes,
        timeSpent: (formFollowup.timeSpentGroup.hours * this.minutesInAnHour) + formFollowup.timeSpentGroup.minutes
      };
      this.inquiryService.saveFollowup(followup).subscribe(
        response => {
          this.followups.push(response)
          this.toastr.success('Follow Up saved successfully.');
        },
        error => console.log('error', error),
        () => {
          this.modalText = 'Follow Up Saved';
          this.openVerticallyCentered(this.alert, 'sm');
          this.refreshFollowup();
          setTimeout(() => this.closePopup(), 750)
        }
      );
    }
    else {
      this.followupForm.markAllAsTouched();
      this.followupForm.get('timeSpentGroup.hours').markAllAsTouched();
      this.followupForm.get('timeSpentGroup.minutes').markAllAsTouched();
      this.toastr.error("Error saving follow up: Time Spent is Required.")
    }
  }

  refreshFollowup() {
    this.updateDate();
    this.followupForm.reset({
      followupId: 0,
      callId: this.callForm.value.callId,
      followupDate: this.currentDateString,
      followupTime: '',
      employeeId: this.baseService.user.userId,
      actionId: this.actionId,
      timeSpent: 0,
      notes: '',
    }, { emitEvent: true })
    this.followupForm.get('timeSpentGroup.hours').patchValue(0);
    this.followupForm.get('timeSpentGroup.minutes').patchValue(0);
  }

  openSearch() {
    this.searchViewMode = 'search';
    this.rebuildSearchTopicOptions();
    this.setDisplayedResults(this.searchResults);
    this.showSearch = true;
  }

  openPossibleMatchesSearch() {
    this.searchViewMode = 'possibleMatches';
    this.rebuildSearchTopicOptions();
    this.setDisplayedResults(this.possibleMatchResults);
    this.showSearch = true;
  }

  submitSearch() {
    let search = this.searchForm.value;
    let searchRequest: ISearchRequest =
    {
      contactTypeId: Number(search.contactTypeId),
      countyId: Number(search.countyId),
      employeeId: search.employeeId,
      fromDate: search.fromDate !== '' ? search.fromDate : null,
      toDate: search.toDate !== '' ? search.toDate : null,
      programId: Number(search.programId),
      topicId: Number(search.topicId),
      secondTopicId: Number(search.secondTopicId),
      tertiaryTopicId: Number(search.tertiaryTopicId),
      statusId: Number(search.statusId)
    };

    this.inquiryService.search(searchRequest).subscribe(
      response => {
        this.searchResults = response;
        this.searchViewMode = 'search';
        this.setDisplayedResults(this.searchResults);
      },
      error => console.log('error', error),
      () => {
        this.rebuildSearchTopicOptions();
      }
    )
  }

  exportCsv() {
    let searchCallIds: number[] = this.displayedResults.map(result => {
      return result.callId
    });

    this.inquiryService.getCsv(searchCallIds).subscribe(
      response => this.downloadFile(this.csvFileName, response),
      error => console.log('error', error)
    );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  updateDate() {
    this.date = new Date();
    this.currentDateString = new Date(this.date.getTime() - (this.date.getTimezoneOffset() * 60000)).toISOString().substring(0, 16);
  }

  changePageSize(size: number) {
    this.pageSize = size;
  }

  private setDisplayedResults(results: ISearchResult[]): void {
    this.displayedResults = results ?? [];
    this.dataSource = new MatTableDataSource<any>(this.displayedResults);
    this.attachTableControls();
  }

  private rebuildSearchTopicOptions(): void {
    const topicId = Number(this.searchForm.get('topicId')?.value || 0);
    const secondTopicId = Number(this.searchForm.get('secondTopicId')?.value || 0);

    this.searchSecondaryTopics = topicId > 0
      ? this.baseService.topics.filter(topic => topic.parentId === topicId && topic.parentId !== topic.topicId)
      : [];
    this.searchTertiaryTopics = secondTopicId > 0
      ? this.baseService.topics.filter(topic => topic.parentId === secondTopicId && topic.parentId !== topic.topicId)
      : [];
  }

  private attachTableControls(): void {
    if (!this.dataSource) {
      return;
    }

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === 'topics') {
        return this.getTopicDisplay(item[property]);
      }
      return item[property];
    };
  }

  openVerticallyCentered(content, size: string) {
    this.modalService.open(content, ({ size:size, centered: true, scrollable: true }) as any);
  }

  closePopup() {
    this.modalService.dismissAll();
    this.showSearch = false;
    this.cdr.detectChanges();
  }
}
